// ⚡️ Server-Sent Events types and helpers.
// 📌 https://en.wikipedia.org/wiki/Server-sent_events
import { z } from 'zod';
/** 1hour TTL for the cache. */
export const EXPIRES_IN_SECONDS = 3_600;
/** 30secs, in case exact-service is down or something. */
export const TIMEOUT_IN_MILLISECONDS = 30_000;
/** Timeout per entity when total is known (5s per item). */
export const TIMEOUT_PER_ENTITY_IN_MS = 5_000;
/** Maximum total timeout for a job stream (60 minutes). */
export const TOTAL_TIMEOUT_IN_MS = 3_600_000;
/** Interval for SSE heartbeat comments to keep connections alive through proxies. */
export const HEARTBEAT_DELAY_IN_MS = 15_000;
/** SSE new progress message. */
export const newProgressMessage = (total) => {
    const message = {
        total,
        succeededCount: 0,
        failedCount: 0,
        status: ProgressStatus.PENDING,
    };
    return message;
};
/** SSE job response schema. */
export const jobResponseSchema = z.discriminatedUnion('status', [
    z.object({
        status: z.literal('noop'),
    }),
    z.object({
        status: z.literal('queued'),
        total: z.number().positive(),
        jobId: z.string().uuid(),
    }),
]);
export const ProgressStatus = {
    PENDING: 'pending',
    IN_PROGRESS: 'in-progress',
    COMPLETE: 'complete',
};
/** SSE message schema. */
export const progressMessageSchema = z.object({
    total: z.coerce.number(),
    succeededCount: z.coerce.number(),
    failedCount: z.coerce.number(),
    status: z.nativeEnum(ProgressStatus),
    error: z.string().optional(),
});
/** Safe JSON parsing of the SSE message with zod parser. */
export const parse = (data) => {
    try {
        const input = typeof data === 'string' ? JSON.parse(data) : data;
        const validation = progressMessageSchema.safeParse(input);
        if (!validation.success) {
            // biome-ignore lint/suspicious/noConsole: Logging for initial release only.
            console.error('Invalid SSE message type', {
                error: validation.error.toString(),
                input: data,
            });
            return;
        }
        return validation.data;
    }
    catch (error) {
        // biome-ignore lint/suspicious/noConsole: Logging for initial release only.
        console.error('Parsing SSE message error', { error, input: data });
        return;
    }
};
/** JSON serializing of the SSE message. */
export const stringify = (data) => {
    return JSON.stringify(data);
};
/** Returns redis key fields for SSE job. */
export const keyFields = (jobId) => {
    const job = `job:${jobId}`;
    const channel = `job-progress:${jobId}`;
    return { job, channel };
};
//# sourceMappingURL=sse.js.map